/**
 * The only numbers the Pilots calculators start from that do not come from
 * HubSpot or Addy's database: the team's own pilot standards and Addy's list
 * prices. Everything else is read live or typed in; nothing is estimated.
 */

/** The team's standard pilot: 3 weeks, one FDE at 20 h/week, 3 LOs × 3 loans. */
export const PILOT_STANDARD = {
  weeks: 3,
  annualSalary: 100000,
  overheadPct: 0,
  hoursPerWeek: 20,
  developers: 1,
  loanOfficers: 3,
  loansPerOfficer: 3,
  runsPerLoan: 1,
};

/** Addy's list prices. */
export const ADDY_LIST_PRICES = {
  pricePerLoan: 99,
  pricePerSeat: 200,
};

export const ROI_TASKS = [
  { key: "preUnderwrite", label: "Pre-underwriting review (credit, income, assets)" },
  { key: "indexing", label: "Document indexing & stacking" },
  { key: "closing", label: "Closing review" },
  { key: "scrub", label: "Scrub & underwriter pre-processing" },
];

/**
 * Client types, matched to HubSpot's "Type of Company" deal property. Brokers
 * buy per seat; everyone else per funded loan.
 */
export const CLIENT_TYPES = [
  { key: "broker", label: "Mortgage broker", hubspotValue: "Mortgage Broker", pricingModel: "perSeat" },
  { key: "retail", label: "Retail lender (IMB, bank, CU)", hubspotValue: "Retail Lender", pricingModel: "perLoan" },
  { key: "hybrid", label: "Hybrid (retail + wholesale)", hubspotValue: "Both / Hybrid", pricingModel: "perLoan" },
  { key: "wholesale", label: "Wholesale / non-QM lender", hubspotValue: "Wholesale Lender", pricingModel: "perLoan" },
  { key: "processing", label: "Processing company", hubspotValue: "Processing Company", pricingModel: "perLoan" },
];

/**
 * What clients have told us on calls, shown next to the inputs as a reference.
 * The calculator never uses them unless someone types them in.
 */
export const ROI_BENCHMARKS = {
  preUnderwrite: "A broker prospect: 30 min per pre-approval review today (demo, 2026-09-03).",
  indexing: "NewFi: a 4–6 hour indexing batch now takes ~7 min per package (call, 2026-09-08).",
  closing: "NewFi: closing review went from 20–25 min to 5–10 min (call, 2026-06-09).",
  scrub: "NewFi: underwriters spend 5–10 min pre-processing a file; an expert scrub ~5 min (calls, 2026-08-21 and 2026-09-08).",
  hourlyCost: "A broker put a processor at $4–6K a month (demo, 2026-08-17).",
  turnTime: "NewFi: doc check to submission “almost knocked off a full day” (call, 2026-08-21).",
};
